import { IntlShape } from 'react-intl'

import { HouseTypeEnum } from '../../../../../lib/graphql'

export const getHouseTypeLabel = ({
  houseType,
  intl,
}: {
  houseType: HouseTypeEnum
  intl: IntlShape
}) => {
  switch (houseType) {
    case HouseTypeEnum.HOTEL:
      return intl.formatMessage({
        id: 'ui.getHouseTypeLabel.hotel',
        defaultMessage: 'Hôtel',
      })
    case HouseTypeEnum.RECEPTION_HALL:
      return intl.formatMessage({
        id: 'ui.getHouseTypeLabel.receptionVenue',
        defaultMessage: 'Lieu de réception',
      })
    case HouseTypeEnum.SELF_MANAGED:
      return intl.formatMessage({
        id: 'ui.getHouseTypeLabel.selfManagedVenue',
        defaultMessage: 'Lieu en gestion libre',
      })
    case HouseTypeEnum.SEMINARS:
      return intl.formatMessage({
        id: 'ui.getHouseTypeLabel.retreatVenue',
        defaultMessage: 'Lieu de séminaire',
      })
    case HouseTypeEnum.VILLAGE_ECOLODGE:
      return intl.formatMessage({
        id: 'ui.getHouseTypeLabel.villageEcolodge',
        defaultMessage: 'Village vacances & ecolodge',
      })
    default:
      return ''
  }
}
